import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import useMediaQuery from "../../hooks/useMediaQuery";
import ProfileImg from "../../assets/images/user.png";
import CameraIcon from "../../icons/cameraIcon";
import styles from "./style.module.css";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UserFile = (props) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const { required, onChange, id, readonly, value } = props;
  const [userImg, setUserImg] = useState(ProfileImg);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [mainFile, setMainFile] = useState(value);

  const handleImageUpload = async (event) => {
    var file = event.target.files[0];
    setMainFile(file);
    if (file) {
      setUserImg(await toBase64(file));
      let tempData = {
        ...userInfo,
        img: await toBase64(file),
      };
      onChange(JSON.stringify(tempData));
      var reader = new FileReader();
      reader.onloadend = function () {
        setUserImg(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setUserImg(ProfileImg);
    }
  };

  const handleDelete = () => {
    setMainFile(null);
    setUserImg(ProfileImg);
  };

  useEffect(() => {
    if (value) {
      let val = JSON.parse(value);
      if (val.img) {
        setUserImg(val.img);
      } else {
        setUserImg(ProfileImg);
      }
      setUserInfo(val);
    }
  }, [value]);

  return (
    <div className={styles.fileInput}>
      <div className={styles.fileInputOuter}>
        <div className={styles.profile_info}>
          <div className={styles.pi_img}>
            <img src={userImg} alt="profile" />
            {isMobile && (
              <label>
                <CameraIcon />
                <input
                  hidden
                  readOnly={readonly}
                  required={required}
                  id={id}
                  accept="image/png,image/jpeg,image"
                  type="file"
                  onChange={handleImageUpload}
                />
              </label>
            )}
          </div>
          {!isMobile && (
            <div className={styles.pi_info}>
              <div className={styles.pi_name}>
                {userInfo.name ? (
                  userInfo.name
                ) : (
                  <div className={styles.pi_skeleton}></div>
                )}
              </div>
              <div className={styles.pi_email}>
                {userInfo.email ? (
                  userInfo.email
                ) : (
                  <div className={styles.pi_skeleton}></div>
                )}
              </div>
              <div className={styles.pi_phone}>
                {userInfo.phone ? (
                  <PhoneInput
                    value={userInfo.phone}
                    disabled
                    disableDropdown
                    containerClass={styles.pi_phone_input}
                  />
                ) : (
                  <div className={styles.pi_skeleton}></div>
                )}
              </div>
            </div>
          )}
        </div>
        {!isMobile && (
          <div className={styles.fileInputUpload}>
            <label>
              <span>{mainFile ? `Upload New Photo` : `Upload Photo`}</span>
              <input
                hidden
                readOnly={readonly}
                required={required}
                id={id}
                accept="image/png,image/jpeg,image"
                type="file"
                onChange={handleImageUpload}
              />
            </label>
            {mainFile && (
              <button type="button" onClick={handleDelete}>
                <span>Delete</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default UserFile;
